import React from 'react';
import PropTypes from 'prop-types';
import StyledButton from "../common/StyledButton";
import Icon from "../SF/MaterialIcon";
import css from "./DeleteAccessKey.css"

/**
 * Displays the delete access key icon button. An instance of the button will be displayed for each access key in the
 * table under the Actions column. When clicked, the delete access key confirmation modal will be displayed.
 * If delete is confirmed, an API call will be made to delete the IAM user with the given access key.
 *
 * @param {Object} props - see propTypes
 * @return {JSX.Element} the delete user icon button.
 */
const DeleteAccessKey = (props) => {
    return (
        <div>
            <StyledButton asLink
                          className={css['delete-button']}
                          aria-disabled={false}
                          onClick={() => {
                              props.setIsOpenDeleteAccessKey(true)
                              props.setDeleteUserName(props.userName)
                          }}
                          id={"Delete-" + props.userName}
                          arial-label={"Delete-" + props.userName}
                          title={"Delete access key"}>
                <Icon icon='cancel' aria-hidden='true'/>
            </StyledButton>
        </div>
    )
}

DeleteAccessKey.propTypes = {
    userName: PropTypes.string.isRequired,
    setIsOpenDeleteAccessKey: PropTypes.func.isRequired,
    setDeleteUserName: PropTypes.func.isRequired
};

export default DeleteAccessKey;
